import { render } from "./MultiFactorAuthCode.vue?vue&type=template&id=40072712"
import script from "./MultiFactorAuthCode.vue?vue&type=script&lang=js"
export * from "./MultiFactorAuthCode.vue?vue&type=script&lang=js"

import "./MultiFactorAuthCode.vue?vue&type=style&index=0&id=40072712&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__